export const jade_green = "#27ae60";
export const pastel_red = "#eb5757"; 



// WEBPACK FOOTER //
// ./src/styles/ColorConsts.js